<script>
	// visual components
	import StartSectionForeground from "./depths/StartSectionForeground.svelte";
	import StartSectionMidground from "./depths/StartSectionMidground.svelte";
	import StartSectionBackground from "./depths/StartSectionBackground.svelte";
	import Chemnitz2025Logo from "../components/Chemnitz2025Logo.svelte";
	import Thanks from "../components/Thanks.svelte";

	// business logic
	import { isPortraitScreen, pageOffset, universalScroll } from '../js/model/stores';
	import { animateElement, freezeElement } from '../js/utils/animate';
	import Parallax from 'parallax-js';

	let _section;
	let _parallaxedSection;
	let parallaxEnabled = false;
	let portrait;
	export let route;

	let animation = (value) => {
		animateElement(value, _section, (currentPageOffset) => {
			_section.style.marginBottom = `calc(23vw - ${currentPageOffset * 0.005}em)`;

			if (_parallaxedSection && !parallaxEnabled) {
				parallaxEnabled = true;
				_parallaxedSection.enable();
			}
		});
		freezeElement(value, _section, (currentPageOffset) => {
			if (_parallaxedSection && parallaxEnabled) {
				parallaxEnabled = false;
				_parallaxedSection.disable();
			}
		});
	};

	let parallax = (universalScrolling) => {

		// Parallax is limited to mobile devices only, that currently do not support universal scrolling
		if (!universalScrolling && !_parallaxedSection) {
			_parallaxedSection = new Parallax(_section, { /* options */ });
			parallaxEnabled = true;
		}
		// else _parallaxedSection.destroy();
	};

	let prepareScene = () => {
		if (!_section) {
			requestAnimationFrame(prepareScene);
			return;
		}

		pageOffset.subscribe(animation);
		universalScroll.subscribe(parallax);
		isPortraitScreen.subscribe((state) => {
			portrait = state;
		});
	};

	prepareScene();

</script>
<style>
	section {
		height: 100vh;
	}

	/* On page load, the mobile browser UI might cover parts of the upper start screen elements. */
	section.portrait {
		height: 90vh;
	}

	/* Parallax.js layers have to inherit the size from its parent scene. */
	div {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}
</style>

<section class:portrait bind:this={_section} id="parallaxScene" data-relative-input="true">
	<div data-depth="0.2"><StartSectionBackground/></div>
	<div data-depth="0.4"><StartSectionMidground/></div>
	<div data-depth="0.5"><StartSectionForeground route={route} /></div>
	<div data-depth="0">
	{#if route === 'home'}
		<Chemnitz2025Logo/>
	{:else}
		<Thanks/>
	{/if}
	</div>
</section>
